import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

import cls from 'classnames/bind';

import debounce from 'lodash/debounce';
import isDate from 'lodash/isDate';
import noop from 'lodash/noop';
import qs from 'qs';

import Dropdown from '@ott/dropdown';
import { withLayoutContext } from '@ott/layout-context';

import PriceChart from './blocks/PriceChart/PriceChart';
import PriceCountries from './blocks/PriceCountries/PriceCountries';
import PriceNights from './blocks/PriceNights/PriceNights';
import actions from './redux/actions';

import styles from './ToursPriceCalendar.scss';

const { changeNights, changeDestinationCountry, changeDepartureCity, getPricesByDays } = actions;

const cx = cls.bind(styles);

// eslint-disable-next-line consistent-return
const prepareDateForQuery = (date) => {
  if (isDate(date)) {
    const dateInISO = date.toISOString().split('T')[0];

    return dateInISO.split('-').reverse().join('.');
  }
};

const departureCities = [
  {
    id: 524901,
    name: 'из Москвы',
  },
  {
    id: 498817,
    name: 'из Санкт-Петербурга',
  },
];

@withRouter
@connect()
@withLayoutContext
class PriceCalendar extends PureComponent {
  static propTypes = {
    nights: PropTypes.number,
    adults: PropTypes.number,
    toCountryId: PropTypes.number,
    fromCityId: PropTypes.number,
    pricesByDays: PropTypes.objectOf(PropTypes.oneOfType(PropTypes.object)),

    /** Для навигации c <a/> вместо <Link/> */
    routeFromOtherApp: PropTypes.bool,

    trackEvent: PropTypes.func,

    /** false используется в seo */
    showFromToControls: PropTypes.bool,
  };

  static defaultProps = {
    trackEvent: noop,
    showFromToControls: true,
  };

  componentDidMount() {
    this.getPricesByDays();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { nights, toCountryId, fromCityId } = this.props;

    const {
      nights: nextNights,
      toCountryId: nextToCountryId,
      fromCityId: nextFromCityId,
    } = nextProps;

    if (nights !== nextNights || toCountryId !== nextToCountryId || fromCityId !== nextFromCityId) {
      this.getPricesByDays({
        nights: nextNights,
        toCountryId: nextToCountryId,
        fromCityId: nextFromCityId,
      });
    }
  }

  getPricesByDays(overrides) {
    const { dispatch, nights, toCountryId, fromCityId } = this.props;

    dispatch(
      getPricesByDays({
        nights,
        toCountryId,
        fromCityId,
        ...overrides,
      })
    );
  }

  handleCountryChange = (toCountryId) => {
    const { dispatch, trackEvent } = this.props;
    dispatch(changeDestinationCountry(toCountryId));
    trackEvent('countryChange');
  };

  handleNightsChange = (nights) => {
    const { dispatch, trackEvent } = this.props;
    dispatch(changeNights(nights));
    trackEvent('nightsChange');
  };

  handleChartScroll = () => {
    const { trackEvent } = this.props;
    trackEvent('chartScroll');
  };

  handleChartScrollDebounced = debounce(this.handleChartScroll, 300);

  handleDateClick = () => {
    const { trackEvent } = this.props;
    trackEvent('dateClick');
  };

  prepareSearchParams = (date) => {
    const { nights, toCountryId, fromCityId, adults } = this.props;

    return qs.stringify({
      from_city: fromCityId,
      to_country: toCountryId,
      start_date: prepareDateForQuery(date),
      nights,
      adults,
    });
  };

  handleDepartureCitySelect = ({ id }) => {
    const { dispatch } = this.props;
    dispatch(changeDepartureCity(id));
  };

  render() {
    const {
      nights,
      toCountryId,
      fromCityId,
      adults,
      pricesByDays: {
        data: { prices },
        ...statuses
      },
      className,
      routeFromOtherApp,
      showFromToControls,
      isTouchDevice,
    } = this.props;

    const selectedDepartureCityIdx = departureCities.findIndex((city) => city.id === fromCityId);

    return (
      <div className={cx('PriceCalendar', className)}>
        <div className={cx('params')}>
          {showFromToControls && (
            <span className={cx('departureCity')}>
              <Dropdown
                initialActiveIdx={selectedDepartureCityIdx}
                items={departureCities}
                onOptionSelect={this.handleDepartureCitySelect}
                size="medium"
                isTouchDevice={isTouchDevice}
                childrenClassNames={{
                  container: cx('departureCity-dropdown'),
                }}
              />
            </span>
          )}

          <span className={cx('nightsBlock')}>
            <PriceNights
              nights={nights}
              onNightsChange={this.handleNightsChange}
              className={cx('nights')}
            />
          </span>
        </div>

        {showFromToControls && (
          <PriceCountries toCountryId={toCountryId} onCountryChange={this.handleCountryChange} />
        )}

        <PriceChart
          prices={prices}
          statuses={statuses}
          nights={nights}
          adults={adults}
          prepareSearchParams={this.prepareSearchParams}
          routeFromOtherApp={routeFromOtherApp}
          onChartScroll={this.handleChartScrollDebounced}
          onDateClick={this.handleDateClick}
        />
      </div>
    );
  }
}

export default PriceCalendar;

export { default as reducer } from './redux';

// bump version, todo rm me
